import { combineReducers } from 'redux';
import { pending } from '@engage/result/pendingResult';
import { SubscriptionUpdatesActionType } from './actionTypes';
import type { UpdatesState } from './types';
import updateReducer from './updateReducer';

export const defaultUpdatesState: UpdatesState = {
  cancellation: pending,
};

export const updatesReducer = combineReducers<UpdatesState>({
  cancellation: updateReducer(
    SubscriptionUpdatesActionType.SubsDigCancelRequest,
    SubscriptionUpdatesActionType.SubsDigCancelSuccess,
    SubscriptionUpdatesActionType.SubsDigCancelFailure,
    SubscriptionUpdatesActionType.SubsDigUpdatesClear,
  ),
});
